"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const jcb = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 38 24",
    "aria-labelledby": (title ? `title-jcb` : '') + (description ? ` desc-jcb` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-jcb"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-jcb"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    id: "------------VI.-CHECKOUT-/-Logged-In-(SDD)",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "jcb-cc",
    fillRule: "nonzero"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M36,0 C37.1,0 38,0.9 38,2 L38,21.8 C38,22.9 37.1,23.8 36,23.8 L2,23.8 C0.9,23.8 0,22.9 0,21.8 L0,2 C0,0.9 0.9,0 2,0 L36,0 Z M36,0.5 L2,0.5 C1.2,0.5 0.6,1.1 0.5,1.9 L0.5,2 L0.5,21.8 C0.5,22.6 1.1,23.2 1.9,23.3 L2,23.3 L36,23.3 C36.8,23.3 37.4,22.7 37.5,21.9 L37.5,21.8 L37.5,2 C37.5,1.2 36.9,0.6 36.1,0.5 L36,0.5 Z",
    id: "Rectangle",
    fill: "#C0C0C0"
  }), /*#__PURE__*/_react.default.createElement("g", {
    id: "JCB",
    transform: "translate(7.000000, 2.900000)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.9,11.4 L20.7,11.4 C20.8,11.4 20.9,11.4 20.9,11.4 C21.2,11.3 21.5,11 21.5,10.6 C21.5,10.2 21.2,9.9 20.9,9.8 C20.8,9.8 20.7,9.8 20.7,9.8 L18.9,9.8 L18.9,11.4 Z",
    id: "Path",
    fill: "#5CB531"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.5,-4.4408921e-16 C18.8,-4.4408921e-16 17.4,1.4 17.4,3.1 L17.4,6.4 L21.8,6.4 C21.9,6.4 22,6.4 22.1,6.4 C23.1,6.5 23.8,7 23.8,7.9 C23.8,8.6 23.3,9.2 22.4,9.3 L22.4,9.3 C23.4,9.4 24.2,9.9 24.2,10.8 C24.2,11.8 23.3,12.4 22.2,12.4 L17.3,12.4 L17.3,18.8 L22,18.8 C23.7,18.8 25.1,17.4 25.1,15.7 L25.1,-4.4408921e-16 L20.5,-4.4408921e-16 Z",
    id: "Path",
    fill: "#5CB531"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.4,8.1 C21.4,7.7 21.1,7.4 20.8,7.4 C20.8,7.4 20.7,7.4 20.6,7.4 L19,7.4 L19,8.9 L20.6,8.9 C20.7,8.9 20.8,8.9 20.8,8.9 C21.1,8.8 21.4,8.5 21.4,8.1 L21.4,8.1 Z",
    id: "Path",
    fill: "#5CB531"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.1,-4.4408921e-16 C1.4,-4.4408921e-16 8.8817842e-16,1.4 8.8817842e-16,3.1 L8.8817842e-16,10.9 C0.9,11.3 1.8,11.6 2.7,11.6 C3.8,11.6 4.4,10.9 4.4,10 L4.4,6.4 L7.1,6.4 L7.1,10 C7.1,11.4 6.2,12.6 3.2,12.6 C1.4,12.6 8.8817842e-16,12.2 8.8817842e-16,12.2 L8.8817842e-16,18.8 L4.6,18.8 C6.3,18.8 7.7,17.4 7.7,15.7 L7.7,-4.4408921e-16 L3.1,-4.4408921e-16 Z",
    id: "Path",
    fill: "#006FBC"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.8,-4.4408921e-16 C10.1,-4.4408921e-16 8.7,1.4 8.7,3.1 L8.7,7.2 C9.5,6.5 10.9,6.1 13.1,6.2 C14.3,6.3 15.6,6.6 15.6,6.6 L15.6,7.9 C15,7.6 14.2,7.3 13.2,7.2 C11.5,7.1 10.5,7.9 10.5,9.4 C10.5,10.9 11.5,11.7 13.2,11.6 C14.2,11.5 14.9,11.2 15.6,10.9 L15.6,12.2 C15.6,12.2 14.3,12.5 13.1,12.6 C10.9,12.7 9.5,12.3 8.7,11.6 L8.7,18.9 L13.3,18.9 C15,18.9 16.4,17.5 16.4,15.8 L16.4,-4.4408921e-16 L11.8,-4.4408921e-16 Z",
    id: "Path",
    fill: "#E60039"
  })))));
};
var _default = exports.default = jcb;